import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LearningResourcesUploadsListComponent } from './learning-resources-uploads-list/learning-resources-uploads-list.component';
import { LearningResourcesUploadsCreateComponent } from './learning-resources-uploads-create/learning-resources-uploads-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: LearningResourcesUploadsListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: LearningResourcesUploadsCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'learning-resources-uploads-create/:id',
        component: LearningResourcesUploadsCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LearningResourcesUploadsRoutingModule { }
